import React from "react";
import { Box, Grid } from "@tiny/components";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";
import SegmentSummary from "../../components/SegmentSummary/SegmentSummary";
import CloneSegmentDialog from "../../components/CloneSegmentDialog/CloneSegmentDialog";
import ViewSegmentContent from "./ViewSegmentContent/ViewSegmentContent";
import ViewSegmentHeader from "./ViewSegmentHeader";
import { useViewSegment } from "./ViewSegment.hooks";
import { ViewSegmentProvider } from "./ViewSegment.context";

function ViewSegment({ segmentId: segmentIdProp }: { segmentId?: string }) {
  const viewSegmentView = useViewSegment(segmentIdProp);

  const { mdUp } = useBreakpoints();

  const {
    filter,
    closeSaveAs,
    saveAsOpen,
    redirectToSavedAs,
    initialSegmentName,
    segmentId,
  } = viewSegmentView;

  return (
    <ViewSegmentProvider value={viewSegmentView}>
      <Box>
        <ViewSegmentHeader />
        <Grid container spacing={5}>
          <Grid item flex="1">
            <ViewSegmentContent />
          </Grid>
          {mdUp && (
            <Grid item flex="0 0 242px">
              <SegmentSummary
                filter={filter}
                hideRefresh
                segmentId={segmentId}
              />
            </Grid>
          )}
        </Grid>
      </Box>
      <CloneSegmentDialog
        segmentId={segmentId!}
        open={saveAsOpen}
        onClose={closeSaveAs}
        onSuccess={redirectToSavedAs}
        name={initialSegmentName}
      />
    </ViewSegmentProvider>
  );
}

export default ViewSegment;
